<div class="modal-header container-fluid ab-modal__header" tabindex="0">
  <div class="ab-modal__close">
    <button
      class="btn btn--link-color btn--no-shadow"
      type="button"
      (click)="activeModal.dismiss()"
    >
      <i class="glyphicon glyphicon--45-deg glyphicon-ab-plus"></i>
      &nbsp;<span class="ab-modal__close__text">Close</span>
    </button>
  </div>
  <div class="modal-body container-fluid ab-modal__body">
    <div class="row">
      <div class="empty-state pt-4 col-12">
        <div class="empty-state__box" *ngIf="!loadingInstructions">
          <ng-container *ngIf="!instructions">
            <span>Step 1 of 2</span>

            <div class="text-center">
              <div class="row">
                <div class="col-8">
                  <h2 class="empty-state__title text-left pb-3">
                    Select a language or framework
                  </h2>
                </div>
                <div class="col-4">
                  <input autocapitalize="off" autocorrect="off" role="combobox" aria-multiline="false" name="searchbox"
                    type="text" placeholder="Search..." abautosizeinput=""
                    class="ab-search__input ab-search__language mt-2 p-2" autocomplete="off" aria-autocomplete="list"
                    aria-expanded="false" (keyup)="fetchLanguageOrFramework($event.target.value)" />
                </div>
              </div>
              <!-- Language Tab links -->
              <!-- Language Tab content Framework list -->
              <div *ngIf="!hasSearchResult">
                <ul ngbNav #nav="ngbNav" [(activeId)]="activeLanguagesTab" class="languages-list ab-tabs">
                  <li [ngbNavItem]="language.value" class="ab-tabs__item"
                    *ngFor="let language of Languages; trackBy: trackByIndex">
                    <a class="ab-tabs__link" ngbNavLink>{{ language.label }}</a>
                    <ng-template ngbNavContent>
                      <ul class="languages-list list-unstyled empty-state-margin-top">
                        <li class="languages-list__item"
                          *ngFor="let fw of language.frameworks; trackBy:
                          trackByIndex" (click)="fetchInstructions(fw)">
                          <span class="languages-list__img language-logo language-logo--{{ fw.value }}"></span>
                          <p class="languages-list__text">{{ fw.label }}</p>
                        </li>
                        <li *ngIf="language.cardVisible" class="languages-list__item"
                          (click)="fetchInstructions(language)">
                          <span class="languages-list__img language-logo language-logo--{{ language.value }}"></span>
                          <p class="languages-list__text">{{ language.label }}</p>
                        </li>
                      </ul>
                    </ng-template>
                  </li>
                </ul>

                <div [ngbNavOutlet]="nav" class="mt-2"></div>
              </div>
              <div *ngIf="hasSearchResult">
                <ul class="languages-list list-unstyled empty-state-margin-top">
                  <li class="languages-list__item"
                    *ngFor="let fw of searchResult; trackBy: trackByIndex" (click)="fetchInstructions(fw)">
                    <span class="languages-list__img language-logo language-logo--{{ fw.value }}"></span>
                    <p class="languages-list__text">{{ fw.label }}</p>
                  </li>
                  <li *ngIf="searchResult.length === 0">
                    <h4 class="empty-state__title text-center pb-3">
                      No such language or framework was found!
                    </h4>
                  </li>
                </ul>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="instructions">
            <div class="d-flex justify-content-between">
              <span>Step 2 of 2</span>

              <button
                class="btn btn--link-color btn--no-shadow btn--default"
                (click)="resetInstructions()"
              >
                <i class="glyphicon glyphicon-angle-left"></i>Back to selection
              </button>
            </div>

            <h2 class="empty-state__title pb-3 mb-n4 text-center">
              <ng-container *ngIf="selectedLanguage.value !== 'other'">
                Install the {{ selectedLanguage.label }} notifier
              </ng-container>

              <ng-container *ngIf="selectedLanguage.value === 'other'">
                Install the Airbrake notifier
              </ng-container>
            </h2>

            <ab-instructions
              class="empty-state-margin-top project-instructions"
              [rawMarkdown]="instructions"
              [language]="selectedLanguage.value"
            ></ab-instructions>

            <div class="help-section text-center">
              <p class="help-section__waiting-for-errors-text" *ngIf="instructions">
                Waiting to receive an error
                <span class="help-section__waiting-for-errors-dot">.</span>
                <span class="help-section__waiting-for-errors-dot">.</span>
                <span class="help-section__waiting-for-errors-dot">.</span>
              </p>
              Need help?
              <button
                class="btn btn--link btn--no-shadow"
                href="mailto:support@airbrake.io?subject=Setup instructions help"
              >
                Send us a message.
              </button>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
